import $ from "jquery"

// Donation form amount picker. Clicking a preset button fills the custom-amount
// field; typing a custom amount clears the preset highlight. Matches the app's
// jQuery-in-sequencers convention (the Stimulus controllers/ dir is not wired
// into the build). Imported by app/javascript/application.js.
$(document).ready(function () {
  const $form = $("#donation-form")
  if (!$form.length) return

  const $amount = $("#donation_custom_amount")

  $form.on("click", ".donation-preset", function (e) {
    e.preventDefault()
    const dollars = $(this).data("amount")
    $amount.val(dollars)
    $(".donation-preset").removeClass("is-selected")
    $(this).addClass("is-selected")
  })

  $amount.on("input", function () {
    $(".donation-preset").removeClass("is-selected")
  })
})
